import React, { Component } from 'react';
import { Button, Col, Row } from 'reactstrap';
import { SlPageTitle, SlSectionTitle } from '../editors';
import { metadataService } from '../../_services';

export class ProfileChange extends Component {
    static displayName = ProfileChange.name;


    render() {
        return (
            <div className="ProfileChange">
                <SlSectionTitle sectionName="ProfileChanged"/>
                <div id="profileChangeSubmitted">
                    <Row className="justify-content-center">
                        <Col xs={12} md={6}>
                            {metadataService.getMessage("ProfileChangesSubmitted")}
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}

